/**
 * Armor of God — sticky mobile Add to Cart bar behavior.
 * Shows the bar once the primary Add to Cart button scrolls out of view,
 * and keeps its enabled/disabled state and label in sync with the primary
 * button (which product-form.js updates as variants change).
 * No cart logic lives here — the sticky button submits the real product
 * form via the HTML `form` attribute.
 */
(function () {
  function init(root) {
    var scope = root || document;
    var bars = scope.querySelectorAll('[data-armor-sticky-atc]:not([data-armor-bound])');

    bars.forEach(function (bar) {
      bar.setAttribute('data-armor-bound', 'true');

      var productInfo = bar.closest('product-info') || document;
      var primaryButton = productInfo.querySelector('.product-form__submit');
      var stickyButton = bar.querySelector('[data-armor-sticky-atc-button]');
      var stickyButtonText = bar.querySelector('[data-armor-sticky-atc-button-text]');

      if (!primaryButton || !stickyButton) return;

      function syncState() {
        var isDisabled = primaryButton.hasAttribute('disabled');
        stickyButton.disabled = isDisabled;

        var primaryText = primaryButton.querySelector('span');
        if (primaryText && stickyButtonText) {
          stickyButtonText.textContent = primaryText.textContent.trim();
        }
      }

      syncState();

      var attributeObserver = new MutationObserver(syncState);
      attributeObserver.observe(primaryButton, { attributes: true, childList: true, subtree: true });

      if ('IntersectionObserver' in window) {
        var visibilityObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              bar.hidden = entry.isIntersecting;
            });
          },
          { rootMargin: '0px 0px -20% 0px' }
        );
        visibilityObserver.observe(primaryButton);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
